module.exports = __webpack_public_path__ + "img/speaker_5.9ab826a0.jpg";